import { defineAsyncComponent } from 'vue';

export const LazyFileUploadModal = defineAsyncComponent(() => import('./File/UploadModal.vue'));
